import { Entity } from "./Entity";
import { DumpsterSize, ServiceType } from "./Order";

export enum DeliveryStatus {
  CREATED = "created",
  SCHEDULED = "scheduled",
  COMPLETE = "complete",
  CANCELED = "canceled",
}

export interface Delivery extends Entity {
  address: string;
  zip: string;
  service: ServiceType;
  dumpsterSize?: DumpsterSize;
  deliveryDate: string;
  status: DeliveryStatus;
  orderId: string;
  driverId?: string;
  name: string;
  instructions: string;
  materialDisposing: string;
  latitude: number;
  longitude: number;
  priority: number;
  city: string;
}

/** A canceled delivery isn't serviced, so it's excluded from schedules/optimization. */
export const isDeliveryCanceled = (d: Pick<Delivery, "status">): boolean =>
  d.status === DeliveryStatus.CANCELED;
